"use strict";

document.addEventListener("DOMContentLoaded", function () {
	
    const COOKIE_ACCEPTANCE = JSON.parse(localStorage.getItem('COOKIE_ACCEPTANCE'));
    const iframeEls = document.getElementsByTagName('iframe');

    if (COOKIE_ACCEPTANCE !== null && COOKIE_ACCEPTANCE.value) {
        
        for (var i = 0; i < iframeEls.length; i++) {
            let iframEl = iframeEls[i];

            if(iframEl.getAttribute('data-src')) {
                iframEl.setAttribute('src', iframEl.getAttribute('data-src'));
                iframEl.removeAttribute('data-src');
            }
        }
    }

    // START -- Add attributes to outer links
    const links = Array.from(document.querySelectorAll('a[href^="http://"], a[href^="https://"]'));
    const currentHostname = window.location.hostname;

    links.forEach(function (link) {
        if (!link.href.includes(currentHostname)) {
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "nofollow");
        }

        if (link.href.endsWith(".pdf") || link.href.endsWith(".html")) {
            link.setAttribute("target", "_blank");
        }
    });
    // END -- Add attributes to outer links

    // START -- Back to top management
    const backToTopButton = document.querySelector(".back-to-top");
    if (backToTopButton) {
        backToTopButton.addEventListener("click", function () {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });
    }
    // END -- Back to top management

    // START - Scroll to anchor
    function gotoAnchor(anchor) {
        const targetElement = document.querySelector(anchor);
        if (targetElement) {
            window.scrollTo({
                top: targetElement.getBoundingClientRect().top + window.scrollY,
                behavior: "smooth",
            });
        }
    }

    const anchorButtons = Array.from(document.querySelectorAll(".btn-anchor"));
    anchorButtons.forEach(function (button) {
        let anchor = null;
        if (button.getAttribute("href") === null) {
            anchor = button.getAttribute("data-anchor");
        } else {
            anchor = button.getAttribute("href");
        }

        button.addEventListener("click", function () {
            gotoAnchor(anchor);
        });
    });
    // END - Scroll to anchor


    // START - Aggiungo aria-label per owl-carousel
    setTimeout(() => {
        var carousels = document.querySelectorAll('.owl-carousel');
        if (carousels.length > 0) {
            // Itera su ciascun elemento carousel
            carousels.forEach(function(carousel) {
                // Trova tutti i punti (dots) all'interno di questo carousel
                var dots = carousel.querySelectorAll('.owl-dot');
                var navs = carousel.querySelectorAll('.owl-nav button');
        
                // Itera su ciascun dot
                dots.forEach(function(dot, index) {
                    // Aggiungi 1 all'indice in modo che parta da 1 invece che da 0
                    var dotIndex = index + 1;
                    // Imposta l'attributo aria-label con il valore dell'indice aggiornato
                    dot.setAttribute('aria-label', dotIndex);
                    dot.removeAttribute('role');
                });

                navs.forEach(function(nav) {
                    nav.setAttribute('aria-label', 'presentation');
                    nav.removeAttribute('role');
                });
            });
        }
    }, 100)
    // END - Aggiungo aria-label per owl-carousel

});
